<template>
  <section class="address-form">
    <div class="form-flex">
      <div class="form-block error__none">
        <span>Room</span>
        <!--        <el-form-item-->
        <!--          ref="addr_room"-->
        <!--          prop="addr_room">-->
        <v-input
          v-model="formData.addr_room"
          :key-non-chinese="true"
          maxlength="5"
          @blur="handleUpdateRoom"/>
        <!--        </el-form-item>-->
      </div>
      <div class="form-block error__none">
        <span>Floor</span>
        <v-input
          v-model="formData.addr_floor"
          :key-non-chinese="true"
          maxlength="5"
          @blur="handleUpdateFloor"/>
      </div>
      <div class="form-block error__none">
        <span>Block</span>
        <el-form-item
          ref="addr_block"
          prop="addr_block">
          <v-input
            v-model="formData.addr_block"
            :key-non-chinese="true"
            maxlength="5"
            @blur="handleUpdateBlock"/>
        </el-form-item>
      </div>
    </div>
    <div class="form-block error__none">
      <span>Building / Estate</span>
      <v-input
        v-model="formData.addr_building"
        :key-non-chinese="true"
        @blur="handleUpdateBuild"/>
    </div>
    <div class="form-block">
      <span>Street</span>
      <el-form-item
        ref="addr_street"
        prop="addr_street">
        <v-input
          v-model="formData.addr_street"
          :key-non-chinese="true"
          @blur="handleUpdateStreet"/>
      </el-form-item>
    </div>
  </section>
</template>

<script>
export default {
  name: 'v-area-input',
  data(){
    return {
      formData: {
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
      }
    }
  },
  computed:{
    isWiriteAddress(){
      let {addr_room,addr_floor,addr_block,addr_building,addr_street} = this.formData||{}
      return addr_room||addr_floor||addr_block||addr_building||addr_street
    }
  },
  watch:{
    isWiriteAddress:{
      immediate:true,
      handler(val){
        this.$emit('update:areaData',val)
      }
    }
  },
  methods:{
    handleUpdateStreet(){
      this.$emit('update:street',this.formData.addr_street)
    },
    handleUpdateBuild(){
      this.$emit('update:build',this.formData.addr_building)
    },
    handleUpdateRoom(){
      this.$emit('update:room',this.formData.addr_room)
    },
    handleUpdateFloor(){
      this.$emit('update:floor',this.formData.addr_floor)
    },
    handleUpdateBlock(){
      this.$emit('update:block',this.formData.addr_block)
    },
  }
}
</script>

<style scoped>

</style>
